import R from 'ramda';

import { createReducer } from 'ha/myredux/createReducer';
import { Actions } from '../constants';

const finishFetchingReducer = () => ({
  isLoaded: true,
  isLoading: false,
});

export default createReducer(
  {
    [Actions.FETCH_FEATURE_FLAGS]: state => ({
      ...state,
      isLoading: true,
    }),
    [Actions.FETCH_FEATURE_FLAGS_SUCCESS]: finishFetchingReducer,
    [Actions.FETCH_FEATURE_FLAGS_FAIL]: finishFetchingReducer,
  },
  {
    isLoaded: false,
    isLoading: false,
  },
);

export const isLoading = R.path(['status', 'isLoading']);
export const isLoaded = R.path(['status', 'isLoaded']);
